import { PositionConfig } from "slotworks/config/asset-config-schema";
import AnimationManager from "slotworks/graphics/animation/animation-manager";
import GraphicsManager from "slotworks/graphics/graphics-manager";
import Layers from "slotworks/graphics/layers/layers";
import { repositionButton } from "slotworks/graphics/layers/populators/reposition-button";
import { repositionToggle } from "slotworks/graphics/layers/populators/reposition-toggle";
import ParticleManager from "slotworks/graphics/particles/particle-manager";
import Point from "slotworks/utils/geom/point";
import Rectangle from "slotworks/utils/geom/rectangle";
import deviceInfo from "slotworks/utils/device-info";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import canvasManager from "slotworks/graphics/canvas/canvas-manager";

export function repositionSprites(sprites: PositionConfig[], layer: Layers) {
    if (sprites) {
        for (const graphicConfig of sprites) {
            const id = graphicConfig.id;
            const name = id.substring(id.lastIndexOf("/") + 1);

            if (name.slice(0, 4) === "btn-") {
                // Buttons
                repositionButton(name.substring(4), graphicConfig, layer);
            } else if (name.slice(0, 9) === "particle-") {
                // particles
                const particleInfo = name.split("-");
                const particleId = particleInfo[1];

                try {
                    const emitter = layer.getParticle(particleId);
                    if(emitter) {
                        emitter.updateSpawnPos(graphicConfig.x, graphicConfig.y);
                    }
                } catch (e) {
                    const particleContainer = new PIXI.Container();
                    const particle = ParticleManager.add(particleId, new Point(graphicConfig.x, graphicConfig.y), particleContainer);

                    layer.addParticle(particleId, particle);
                    layer.container.addChildAt(particleContainer, 0);
                }
            } else if (name.slice(0, 5) === "anim-") {
                // Animations
                const animOptions = name.split("-");

                const animationId = animOptions[1];
                let instanceId = animationId;
                let autoplay = true;

                if (animOptions.length > 2) {
                    instanceId = animOptions[2];
                    if (instanceId === "true" || instanceId === "false") {
                        autoplay = instanceId === "true";
                        instanceId = animationId;
                    }
                }
                if (animOptions.length > 3) {
                    autoplay = animOptions[3] === "true";
                }

                if (AnimationManager.hasScriptedAnimationFactory(animationId)) {
                    // const animPosition = new Rectangle(graphicConfig.x, graphicConfig.y, graphicConfig.width, graphicConfig.height);
                    // const anim = AnimationManager.createScriptedAnimation(animationId, animPosition);

                    // layer.addScriptedAnimation(instanceId, anim);

                    // if (autoplay) {
                    //     anim.play();
                    // } else {
                    //     anim.getContainer().visible = false;
                    // }

                    // layer.container.addChildAt(anim.getContainer(), 0);

                } else {
                    let anim = layer.container.getChildByName(instanceId) as AnimatedSprite;
                    if(!anim) {
                        anim = GraphicsManager.createAnimation(animationId);
                        if (autoplay) {
                            anim.play();
                        }
                    }
                    anim.x = graphicConfig.x;
                    anim.y = graphicConfig.y;
                    anim.width = graphicConfig.width;
                    anim.height = graphicConfig.height;
                    anim.name = instanceId;

                    if(anim.anchor.x > 0) {
                        anim.x += anim.anchor.x * anim.width;
                    }

                    if(anim.anchor.y > 0) {
                        anim.y += anim.anchor.y * anim.height;
                    }

                    if (autoplay) {
                    //    anim.play();
                    } else {
                        anim.visible = false;
                    }

                    layer.container.addChildAt(anim, 0);
                }
            } else if (name.slice(0, 6) === "shape-") {
                const shapeParams = name.slice(6).split("-");

                const shapeName = shapeParams[0];
                const shapeFillColor = parseInt(shapeParams[1], 16);
                const shapeFillAlpha = shapeParams.length > 2 ? parseFloat(shapeParams[2]) / 100 : 1;
                const shapeStrokeColor = shapeParams.length > 3 ? parseInt(shapeParams[3], 16) : shapeFillColor;
                const shapeStrokeSize = shapeParams.length > 4 ? parseFloat(shapeParams[4]) : 0;
                const shapeStrokeAlpha = shapeParams.length > 5 ? parseFloat(shapeParams[5]) / 100 : shapeFillAlpha;

                let shape = layer.container.getChildByName(shapeName) as PIXI.Graphics;

                if(!shape) shape = new PIXI.Graphics();
                
                shape.clear();

                shape.lineStyle(shapeStrokeSize, shapeStrokeColor, shapeStrokeAlpha);
                shape.beginFill(shapeFillColor, shapeFillAlpha);

                // Shape with name fullscreen will take the whole available canvas
                if(shapeName == "fullscreen") {
                    const global = new Point(0, 0);
                    const local = layer.globalToLocal(global);
                    shape.position.set(local.y, local.x);
                    const bigger = canvasManager.stageWidth > canvasManager.stageHeight ? canvasManager.stageWidth : canvasManager.stageHeight;
                    shape.drawRect(-bigger/2, -bigger/2, bigger * 2, bigger * 2);
                } else {
                    shape.drawRect(0, 0, graphicConfig.width, graphicConfig.height);
                    shape.x = graphicConfig.x;
                    shape.y = graphicConfig.y;
                }
                shape.name = shapeName;

                layer.container.addChildAt(shape, 0);
            } else if (name.slice(0, 4) === "tgl-") {
                // // Toggle buttons
                repositionToggle(name.substring(4), graphicConfig, layer);
            } else if(name.slice(0, 6) === "spine-") {
                const options = name.split("-");
                
                if(options[1] === "sequence") {
                    const sequenceId = options[3];
                    
                    const spineSequence = layer.getSpineSequence(sequenceId);
                    
                    spineSequence.container.x = graphicConfig.x;
                    spineSequence.container.y = graphicConfig.y;
                } else {
                    const spineId = options[1];

                    const spine = layer.getSprite(spineId);

                    spine.x = graphicConfig.x;
                    spine.y = graphicConfig.y + graphicConfig.height;
                }
            } else {
                
                const sprite = layer.container.getChildByName(name) as PIXI.Sprite;
                if(sprite) {
                    if(GraphicsManager.hasTexture(id)) {
                        sprite.texture = GraphicsManager.getTexture(id);
                    }
                    sprite.width = graphicConfig.width;
                    sprite.height = graphicConfig.height;
                    sprite.x = graphicConfig.x + sprite.width * sprite.anchor.x;
                    sprite.y = graphicConfig.y + sprite.height * sprite.anchor.y;
                } else {
                    // Sprites
                    let sprite;
                    if(deviceInfo.hasTwoOrientations()) {
                        const ids = [ id ];
                        ids.unshift(
                            (deviceInfo.layoutPrefix == "portrait-" ? "landscape-" : "portrait-") +
                            id.slice(deviceInfo.layoutPrefix.length, id.length)
                        );
                        sprite = GraphicsManager.createSprite(ids);
                    } else {
                        sprite = GraphicsManager.createSprite(id);
                    }
                    
                    sprite.x = graphicConfig.x;
                    sprite.y = graphicConfig.y;
                    sprite.width = graphicConfig.width;
                    sprite.height = graphicConfig.height;
                    sprite.name = name;

                    layer.container.addChildAt(sprite, 0);
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/graphics/layers/populators/reposition-sprites.ts